import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import InfoMortalidad from "./InfoMortalidad";
import IndicadorMortalidadManual from "../../Manual/IndicadorMortalidadManual";
import Swal from "sweetalert2";

function MortalidadInstitucional() {
  const cookies = new Cookies();
  const tipoUsuario = parseInt(cookies.get("tipo_Usuario"));

  const [isLoading, setLoading] = useState(false);
  const [archivos, setArchivos] = useState(null);
  const [postGrupo, setPostGrupo] = useState("");
  const [instituciones, setInstituciones] = useState([]);
  const [institucionSeleccionada, setInstitucionSeleccionada] = useState("");

  useEffect(() => {
    if (tipoUsuario === 1) {
      obtenerInstituciones();
    }
  }, []);

  const obtenerInstituciones = async () => {
    try {
      const response = await axios.get(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerInstituciones",
      );
      setInstituciones(response.data);
    } catch (error) {
      console.error("Error al obtener las instituciones:", error);
    }
  };

  const subirArchivos = (e) => {
    setArchivos(e);
  };

  const insertarArchivos = async () => {
    if (!postGrupo) {
      Swal.fire("Debe seleccionar un grupo", "", "warning");
      return;
    }

    if (tipoUsuario === 1 && !institucionSeleccionada) {
      Swal.fire("Debe seleccionar una institución", "", "warning");
      return;
    }

    const f = new FormData();
    for (let index = 0; index < archivos.length; index++) {
      f.append("files", archivos[index]);
    }

    const institucionId =
      tipoUsuario === 1
        ? institucionSeleccionada
        : cookies.get("institucionid");

    const username = "BasicAuth@icontec.org";
    const password = "yQLzqmR7eZSuAmQZUqhY";
    const basicAuth = btoa(`${username}:${password}`);

    setLoading(true);

    try {
      const response = await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/CargaMasivosIndicadorMortalidad?Grupo=${postGrupo}&InstitucionId=${institucionId}`,
        f,
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
          },
        },
      );

      Swal.fire({
        title: response.data,
        icon: "success",
      }).then(() => window.location.reload("/"));
    } catch (error) {
      Swal.fire({
        title: "Error al subir archivo",
        text: error.message,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Indicadores Grupo C2
                </h6>
              </div>

              {(tipoUsuario === 1 || tipoUsuario === 2) && (
                <a
                  href="../../Indicadores/FormatoIndicadorMortalidad.csv"
                  download
                >
                  Descargar Formato
                </a>
              )}

              <div className="card-body">
                {(tipoUsuario === 1 || tipoUsuario === 2) && (
                  <div className="table-responsive">
                    <table
                      className="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <td>Escoja el grupo a insertar</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {tipoUsuario === 1 && (
                              <div className="mb-3">
                                <label className="font-weight-bold">
                                  Seleccione institución:
                                </label>
                                <select
                                  className="form-control"
                                  value={institucionSeleccionada}
                                  onChange={(e) =>
                                    setInstitucionSeleccionada(e.target.value)
                                  }
                                >
                                  <option value="">
                                    Seleccione institución
                                  </option>
                                  {instituciones.map((inst) => (
                                    <option key={inst.id} value={inst.id}>
                                      {inst.razon_Social}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                            <hr />
                            <select
                              className="form-control"
                              value={postGrupo}
                              onChange={(e) => setPostGrupo(e.target.value)}
                            >
                              <option value="">Seleccione</option>
                              <option value="c2">
                                C2. Primeras causas de mortalidad institucional
                              </option>
                              <option value="c2.1">
                                C2.1 Mortalidad hosp. General Adultos
                              </option>
                              <option value="c2.2">
                                C2.2 Mortalidad hosp. Pediatría
                              </option>
                              <option value="c2.3">
                                C2.3 Mortalidad Ginecobstetricia
                              </option>
                              <option value="c2.4">
                                C2.4 Mortalidad urgencias
                              </option>
                              <option value="c2.5">
                                C2.5 Mortalidad cirugía
                              </option>
                              <option value="c2.6">
                                C2.6 Mortalidad cuidados intensivos
                              </option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              type="file"
                              name="files"
                              accept=".csv"
                              multiple
                              onChange={(e) => subirArchivos(e.target.files)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {!isLoading ? (
                              <button
                                className="btn btn-primary btn-block"
                                onClick={insertarArchivos}
                              >
                                Guardar
                              </button>
                            ) : (
                              <button
                                className="btn btn-secondary btn-block"
                                disabled
                              >
                                Cargando...
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                <InfoMortalidad />
              </div>
            </div>
          </div>
        </div>
        <IndicadorMortalidadManual />
      </div>
    </Fragment>
  );
}

export default MortalidadInstitucional;
